<template>
  <div class="divmain">
    <el-row>
      <el-col :span="24" class="divcontent">
        <h3>问答</h3>
      </el-col>
    </el-row>
    <el-row v-loading="loading">
      <el-col :span="24" class="divcontent">
        <router-link :to="{ name: 'ques_view', query: { d: item.question_guid }}" v-for="item in question" :key="item.question_guid">
          <el-card class="box-card-ques" shadow="hover" style="margin-top:20px;">
            <div slot="header" class="ques-content clearfix">
              <span>
                <el-tag>{{item.pro_category_title}}</el-tag>
              </span>
              <span>&nbsp;{{item.question_title}}</span>
              <span style="float: right; padding: 3px 0;color:#909399" type="text">{{item.question_addtime}}</span>
              <div class="clearfix"></div>
            </div>
            <div class="ques-foot" style="text-align: right">
              <el-tag type="success">{{item.question_browse}}浏览</el-tag>
              &nbsp;&nbsp;<el-tag type="success">{{item.question_ans}}回答</el-tag>
              &nbsp;&nbsp;<el-tag type="success">{{item.question_feed}}评论</el-tag>
            </div>
          </el-card>
        </router-link>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getQuestion } from "@/api/ayv3/base";
export default {
  name: "question",
  components: {

  },
  data() {
    return {
      loading: true,
      question: [],
      take: 26
    }
  },
  methods: {
    //取问答
    getQuestion(pagenum) {
      var postparam = {
        skipnum: this.take * (pagenum - 1),
        takenum: this.take
      };
      getQuestion(postparam).then(res => {
        if (res.data.code === 0) {
          this.question.push(...res.data.data);
          this.loading = false;
        } else {
          this.$alert(res.data.message, '提示');
        }
      })
    },
  },
  mounted() {
    this.getQuestion(1);
  }
};
</script>
<style lang="less">
.box-card-ques {
  float: left;
  width: 300px;
  height: 300px;
  margin-right: 10px;
  .el-card__header {
    border: 0;
  }
  .ques-content {
    float: left;
    width: 100%;
    height: 220px;
    padding-bottom: 10px;
    overflow: hidden;
  }
  .ques-foot {
    float: left;
    width: 100%;
    height: 50px;
    padding: 10px 0 0 0;
    border-top: 1px solid #dcdfe6;
  }
}
@media screen and (max-width: 1066px) {
  .box-card-ques {
    width: 100%;
  }
}
</style>

